"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/VUFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_249)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_249`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0.000244141H36V23.9998H0V0.000244141Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M36 12V23.9998H0L15.1302 12H36Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M36 0.000244141V12H15.1302L0 0.000244141H36Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.5391 10.8261L1.88916 0.000244141H0.629719L15.2665 11.6087H36V10.8261H15.5391ZM0.629719 23.9998H1.88916L15.5391 13.1739H36V12.3913H15.2665L0.629719 23.9998ZM0 0.499675V1.49854L13.2411 12L0 22.5015V23.5003L14.5005 12L0 0.499675Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0.629719 0.000244141H0V0.499675L14.5005 12L0 23.5003V23.9998H0.629719L15.2665 12.3913H36V11.6087H15.2665L0.629719 0.000244141Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.48016 14.558V13.5529C5.48317 13.5529 6.29915 12.7369 6.29915 11.734C6.29915 11.0244 5.72181 10.4471 5.01215 10.4471C4.52875 10.4471 4.13542 10.8403 4.13542 11.3238C4.13542 11.633 4.38693 11.8845 4.69609 11.8845C4.78012 11.8844 4.86068 11.8509 4.9201 11.7915C4.97952 11.7321 5.01295 11.6515 5.01306 11.5675H6.01818C6.01818 12.2965 5.42509 12.8897 4.69616 12.8897C3.83279 12.8895 3.13037 12.187 3.13037 11.3237C3.13037 10.2861 3.97454 9.44189 5.01222 9.44189C6.27609 9.44189 7.30434 10.4701 7.30434 11.734C7.30434 13.2911 6.03744 14.558 4.48016 14.558Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_249`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as VUFlag };
